import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';

interface IModalLegalProps {
  open: boolean;
  toggle: any;
}

export default function ModalBenefits(props: IModalLegalProps) {
  const { open = true, toggle } = props;

  return (
    <Modal modalClassName="format-new-modal" isOpen={open} size="lg" fade={false}>
      <div className="modal-header">
        <div className="close-modal-header w-100 d-flex text-align-left justify-content-between">
            <img
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_chevron.svg"
                alt=""
                onClick={toggle(false)}
            />
            <img 
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Action%20Group.svg"
                alt=""
                onClick={toggle(false)}
            />
        </div>
        <h4 className="modal-title px-20">Beneficios</h4>
      </div>
      <ModalBody className="px-16">
        <p>Cuenta con un 70% de descuento en:</p>
        <ul>
          <li>Cristales, marcos y lentes de contacto.</li>
          <li>Prótesis y órtesis.</li>
          <li>Cirugía Lasik.</li>
          <li>Cirugía por obesidad.</li>
        </ul>
        <p>Además, accede a MetLife Orienta: www.metlifeorienta.cl</p>
      </ModalBody>
    </Modal>
  );
}